import { useEffect, useState, useRef } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import { useLazyGetPicklistDetailsQuery, usePostUpdatePickListMutation, usePostSubmitPickListMutation } from '../../../../store/api/picklist'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import PrintModal from "../../../../../src/Core/Print/PrintModal";
import Attachment from '../../../../utils/Attachment'
import { useGetBulkPickListDetailQuery } from '../../../../store/api/purchasereturnbulkapi'

function Pick({ pickListId }) {
    const nvg = useNavigate()
    const scanItemRef = useRef(null);
    const [tab, settab] = useState(1)
    const [result, setResult] = useState(false)
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [item_Rows, setitem_Rows] = useState([]);
    const [originalItems, setOriginalItems] = useState([]);
    const [fulldata, setfulldata] = useState();
    const [scannedserialNo, setscannedserialNo] = useState([]);
    const [current_scanned_bin, setCurrent_Scanned_Bin] = useState('');
    const [scannedItem, setScannedItem] = useState('');
    const [scanboll, setscanboll] = useState(false);
    const [submit, setsubmit] = useState(false);
    const [update, setupdate] = useState(false);
    const [selectRow, setselectRow] = useState("");
    const [newPageNumber, setnewPageNumber] = useState(1);
    const [activityboll, setactivityboll] = useState(false)
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [checkbool, setcheckbool] = useState(false)
    const [trigger] = useLazyGetPicklistDetailsQuery();
    const {data:listData,refetch} = useGetBulkPickListDetailQuery({"doctype":"Pick List","name":pickListId});
     useEffect(()=>{
        if(pickListId){
            refetch();
        }
     },[pickListId])


     
    useEffect(() => {
    const fetchPicklist = async () => {
        try {

            setfulldata(listData.docs[0]);
            let updatedRows = listData?.docs?.[0]?.locations.map(item => ({
            ...item,
            picked_qty: 0,
            Sno: item?.serial_no ? item?.serial_no?.split(/[\n\\]+/) : [],
            Scanned_Sno: []
            }));
             console.log("check 1",updatedRows);
            setscanboll(true);
            setItemList(updatedRows);
            setOriginalItems(updatedRows);
            setitem_Rows(updatedRows);
        } catch (error) {
            console.error("Error fetching picklist:", error);
        }
    };


    if (pickListId) {
         fetchPicklist();
     }

    }, [pickListId,listData]);


    const handleBinScan = (e) => {
        scanItemRef.current?.focus();
        e.preventDefault();
        if (current_scanned_bin.trim()) {
            const filtered = originalItems.filter(item => item.warehouse === current_scanned_bin.trim());
            setitem_Rows(filtered);
        } else {
            handleClearBinFilter();
        }
        setnewPageNumber(1);
    };

    const handleClearBinFilter = () => {
        setCurrent_Scanned_Bin('');
        const updatedOriginalItems = originalItems.map(origItem => {
            const updated_SItem = item_Rows.find(updatedItem => updatedItem.item_code === origItem.item_code && updatedItem.batch_no === origItem.batch_no && updatedItem?.serial_no && origItem?.serial_no);
            const updated_NSItem = item_Rows.find(updatedItem => updatedItem.item_code === origItem.item_code && updatedItem.warehouse === origItem.warehouse && !updatedItem?.serial_no && !origItem?.serial_no);
            if (updated_SItem && updated_SItem != undefined) {
                return {
                    ...origItem,
                    picked_qty: updated_SItem?.picked_qty,
                    Scanned_Sno: updated_SItem?.Scanned_Sno,
                };
            }
            if (updated_NSItem && updated_NSItem != undefined) {
                return {
                    ...origItem,
                    picked_qty: updated_NSItem?.picked_qty,
                };
            }     
            return {
                    ...origItem
                };
        });

        setitem_Rows(updatedOriginalItems);
        setOriginalItems(updatedOriginalItems)
    };

    const handleItemScan = (e) => {
        e.preventDefault();
        setScannedItem("");

        if (scannedItem.trim()) {
            let matchedItem = null;
            const serialItem = item_Rows.filter((item) => item.Sno?.includes(scannedItem));
            if (serialItem.length > 0) {
                const filtered = item_Rows.map((item) => {
                    if (item.batch_no === serialItem[0].batch_no) {
                        if (!(item.warehouse == current_scanned_bin.trim())) {
                            setError(`Item needs to be in the same Warehouse`);
                            setShowError(true);
                            return item;
                        }
                        const currentPickedQty = parseInt(item.picked_qty || 0);
                        const totalQty = parseInt(item.qty || 0);

                        if (currentPickedQty >= totalQty) {
                            setError(`Picked quantity exceeds available quantity`);
                            setShowError(true);
                            return item;
                        }

                        if (scannedserialNo.includes(scannedItem)) {
                            setError(`Serial number ${scannedItem} already scanned`);
                            setShowError(true);
                            return item;
                        }
                        setscannedserialNo([...scannedserialNo, scannedItem]);
                        item.picked_qty = currentPickedQty + 1;
                        item.Scanned_Sno = [...item.Scanned_Sno, scannedItem];
                        matchedItem = { ...item };
                        setnewPageNumber(1)
                    }

                    return item;
                });

                if (matchedItem !== null) {

                    const updatedList = [
                        matchedItem,
                        ...filtered.filter((item) => item.batch_no !== matchedItem.batch_no),
                    ];

                    setitem_Rows(updatedList);
                    setselectRow(matchedItem);
                    setnewPageNumber(1)

                }
                return;

            }




            const filtered = item_Rows.map((item) => {

                if(item.item_code == scannedItem.trim()){
                    if(item.Sno[0]){
                        return item;
                    }
                }
                if (!(item.warehouse == current_scanned_bin.trim())) {
                    setError(`Item needs to be in the same Warehouse`);
                    setShowError(true);
                    return item;
                }

                if (item.item_code === scannedItem.trim()) {
                    const currentPickedQty = parseInt(item.picked_qty || 0);
                    const totalQty = parseInt(item.qty || 0);

                    if (currentPickedQty >= totalQty) {
                        setError(`Picked quantity exceeds available quantity`);
                        setShowError(true);
                        return item;
                    }

                    item.picked_qty = currentPickedQty + 1;
                    matchedItem = { ...item };
                    setnewPageNumber(1)

                }

                return item;
            });

            console.log("check all item is here or not",filtered);
            if (matchedItem !== null) {
                const updatedList = [
                    matchedItem,
                    ...filtered.filter((item) => item.item_code !== matchedItem.item_code),
                ];

                setitem_Rows(updatedList);
                setselectRow(matchedItem);
            }


        }


    };

    const totalPickedQty = item_Rows.reduce((total, item) => {
        return total + (Number(item?.picked_qty) || 0);
    }, 0);

    const totalQty = item_Rows.reduce((total, item) => {
        return total + (item?.order_qty || 0);
    }, 0);

    const totalaccepted = item_Rows.reduce((total, item) => {
        return total + (item?.qty || 0);
    }, 0);

 


    const [postsubmitPicklist] = usePostSubmitPickListMutation();

    const handleClicksubmit = () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }

        const payload = {
            name: pickListId,

        };


        postsubmitPicklist(payload)
            .unwrap()
            .then(res => {
                setsubmit(true)
                setError('Submited');
                setptype('Picklist submited');
                setShowError(true);
                setactivityboll(prev => !prev);

            })
            .catch(err => {
                console.error('Error creating picklist:', err);
            });
    };



    const handleDevlivaryPick = async () => {
        try {
            localStorage.removeItem("deliveryNoteId");
            nvg('/outbound/outbound-create-delivery-note', {
                state: { picklist_id: pickListId, is_new: true }
            });
        } catch (error) {
            console.error('Failed to create pick:', error);
            alert('Error creating pick. Please try again.');
        }
    };





    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Inbound Return</p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/pick/outboundpick')}>Pick List </p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        New Bulk Pick
                        <button
                            className={` ${submit
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {submit ? 'Submitted' : scanboll ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    {submit && <Button
                        style={{ gap: '2px' }}
                        className="custom-btn-00989"
                        iconName="LuFilePlus2"
                        iconSize={12}
                        onClick={handleDevlivaryPick}
                    >
                        Create Delivary note
                    </Button>}

                   
                 
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleClicksubmit}
                        >
                            Submit
                        </Button>
                  
                    {update && (
                        <p className="p-0 m-0">
                            <img src={printerimg}
                                onClick={() => setShowPrintModal(true)}
                                className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
                        </p>
                    )}
                </div>
            </div>
            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        {pickListId && <Attachment doctype="Pick List" docname={pickListId} />}
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 fulldata={fulldata} pickListId={pickListId} activityboll={activityboll} picklist_id={pickListId} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            {/* Left Side Text Info */}
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <p className="NoOfLine">
                                    No. of lines - <span style={{ color: '#2563EB' }}>{item_Rows.length}</span>
                                </p>
                                <p className="TotalQty">
                                    Total Quantity - <span style={{ color: '#16A34A' }}>{totalaccepted > 0 ? totalaccepted : totalQty}</span>
                                </p>
                                {/* <p className="ReceivedQty">
                                    Scanned Quantity - <span style={{ color: '#EC642A' }}>{totalPickedQty}</span>
                                </p> */}
                            </div>
                            {/* {scanboll &&
                                <div className="d-flex mx-2" style={{ gap: '10px', borderColor: 'rgba(0,0,0,0.2)' }}>
                                    <form onSubmit={handleBinScan}>
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                name="binScan"
                                                placeholder="Scan Bin"
                                                className="form-control pe-4"
                                                value={current_scanned_bin}
                                                onChange={(e) => setCurrent_Scanned_Bin(e.target.value)}
                                                style={{
                                                    width: '227px',
                                                    border: '1px solid #333',
                                                    fontSize: '12.8px'
                                                }}
                                            />
                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    color: "#EC642A",
                                                    fontSize: '12.8px'
                                                }}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>
                                    </form>



                                    <form onSubmit={handleItemScan}>
                                        <div className="position-relative" style={{ width: '227px' }}>
                                            <div
                                                style={{ position: 'relative' }}
                                                title={!current_scanned_bin ? 'Scan Bin' : ''}
                                            >
                                                <input
                                                    ref={scanItemRef}
                                                    type="text"
                                                    placeholder="Scan Item"
                                                    className="form-control pe-4"
                                                    value={scannedItem}
                                                    onChange={(e) => setScannedItem(e.target.value)}
                                                    disabled={!current_scanned_bin}
                                                    style={{
                                                        width: '100%',
                                                        border: '1px solid #333',
                                                        backgroundColor: !current_scanned_bin ? '#f1f1f1' : 'white',
                                                        cursor: !current_scanned_bin ? 'not-allowed' : 'text',
                                                        fontSize: '12.8px'
                                                    }}
                                                />

                                                {!current_scanned_bin && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            right: '40px',
                                                            transform: 'translateY(-50%)',
                                                            pointerEvents: 'none',
                                                            color: '#999',
                                                        }}
                                                    >
                                                        <GetIcon iconName="MdBlock" size={16} />
                                                    </div>
                                                )}
                                            </div>

                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                disabled={!current_scanned_bin}
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: !current_scanned_bin ? 'not-allowed' : 'pointer',
                                                    color: "#EC642A",
                                                }}
                                                title={!current_scanned_bin ? 'Scan Bin' : 'Submit'}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>

                                    </form>
                                </div>} */}

                        </div>

                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            pageNo={{ newPageNumber, setnewPageNumber }}
                            scannedserialNo={{ setscannedserialNo, scannedserialNo }}
                            list_data={itemList}
                            fulldata={fulldata}
                            row={{ Rows: item_Rows, setRows: setitem_Rows, selectRow, setselectRow }}
                            scanboll={scanboll}
                            submit={submit} />

                    </div>
                </div>
                {showPrintModal && (
                    <PrintModal
                        onClose={() => setShowPrintModal(false)}
                        documentId={pickListId}
                        doctype="Pick List"
                        title="Print GRN"
                    />
                )}
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </div>
        </>
    )
}

export default Pick